import { useHistory } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { clearLocalStorage } from "./useLocalStorage";
import { useWebSocket } from "./useWebSocket";

const useAxiosInterceptors = () => {
  const history = useHistory();

  const handleTokenExpiration = useCallback(() => {
    console.log("Token ha expirado, limpiando localStorage y redirigiendo...");
    clearLocalStorage();
    setTimeout(() => history.push("/login"), 500);
  }, [history]);

  // Maneja el cierre de sesión desde el WebSocket
  useWebSocket(() => {
    console.log("Cierre de sesión detectado desde WebSocket");

    handleTokenExpiration();
  });

  useEffect(() => {
    const handleLogout = () => {
      console.log("Logout detectado desde evento global");
      handleTokenExpiration();
    };
  
    window.addEventListener("logout", handleLogout);
  
    return () => {
      window.removeEventListener("logout", handleLogout);
    };
  }, [handleTokenExpiration]);

  return null;
};

export { useAxiosInterceptors };
